
export default function SplashScreen() {
   return (
      <div className="md:fixed left-0 top-0 hidden bg-blue-600 min-h-screen md:flex md:items-center md:justify-center w-[25vw] max-w-lg">
         <h1 className="m-auto text-5xl font-bold text-white">
            Ledga
         </h1>
      </div>
   )
}